import { AxiosInstance } from "axios";
import { toast } from "react-toastify";

export interface FavoriteAddParameters {
  cu_id: string;
  stock_id: string;
}

interface FavoriteAddResponse {
  err: string;
  message?: string;
}

export const favoriteAdd = async (
  axios: AxiosInstance,
  { cu_id, stock_id }: FavoriteAddParameters
) => {
  const requestData = JSON.stringify({
    cu_id,
    stock_id,
  });

  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };
  try {
    const { data } = await axios.post<FavoriteAddResponse>(
      "api2/Favorite/FavoriteAdd",
      requestData,
      { headers }
    );
    if (!data) {
      return { err: "9999", message: "加入失敗" };
    }
    data.err === "0000" &&
      toast.success(`加入自選成功:${"(" + data.err + ")"}`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

    data.err !== "0000" &&
      toast.success(`${data?.message + "(" + data.err + ")"}`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    return data;
  } catch (error) {
    (window.parent as any).reactLogout(`登入閒置已超過20分鐘，請重新登入。 Error:${error}`);
    return { err: "9999", message: "加入失敗" };
  }
};
